module.exports = __webpack_public_path__ + "img/vbH.ca077cbe.png";